module.exports = {"title":"Programmakaart De Dag 2020","date":"2017-12-27T00:00:00Z","layout":"post","attachment":"kaart29.pdf","linktext":"Lees kaart","body":"<p>Hier kunt u de programmakaart van De Dag van de Religieuze Film editie 29 (2020) downloaden.</p>\n"}


//////////////////
// WEBPACK FOOTER
// ./blog/2017-12-27 Programakaart De Dag/index.md
// module id = 973
// module chunks = 0